// Orden, filtros por columna y facetas de una tabla cuyos datos ya están en el panel.
// Misma semántica que el servidor: vacíos al final, `__vacio__` para filtrar por vacío.
import { VACIO } from './filtros';

const vacio = (v) => v === null || v === undefined || v === '';
const sinTildes = (t) => String(t).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

const pasaFiltro = (valor, f) => {
  if (f.valores?.length) return f.valores.includes(vacio(valor) ? VACIO : String(valor));
  if (f.desde || f.hasta) {
    const dia = vacio(valor) ? '' : new Date(valor).toISOString().slice(0, 10);
    return !!dia && (!f.desde || dia >= f.desde) && (!f.hasta || dia <= f.hasta);
  }
  if (f.texto) return !vacio(valor) && sinTildes(valor).includes(sinTildes(f.texto));
  return true;
};

export const filtrarFilas = (filas, filtros, busqueda, camposBusqueda, excluir) =>
  filas.filter((fila) => {
    const q = sinTildes((busqueda || '').trim());
    if (q && !camposBusqueda.some((c) => sinTildes(fila[c] ?? '').includes(q))) return false;
    return Object.entries(filtros).every(([id, f]) => id === excluir || pasaFiltro(fila[id], f));
  });

export const ordenarFilas = (filas, sortBy, sortDir) => {
  if (!sortBy) return filas;
  const dir = sortDir === 'desc' ? -1 : 1;
  return [...filas].sort((a, b) => {
    const x = a[sortBy];
    const y = b[sortBy];
    if (vacio(x) && vacio(y)) return 0;
    if (vacio(x)) return 1; // los vacíos siempre al final
    if (vacio(y)) return -1;
    if (typeof x === 'number' && typeof y === 'number') return (x - y) * dir;
    return String(x).localeCompare(String(y), 'es', { numeric: true }) * dir;
  });
};

/** Valores de una columna con su recuento, bajo los demás filtros (no el suyo). */
export const facetasDe = (filas, columna, filtros, busqueda, camposBusqueda) => {
  const base = filtrarFilas(filas, filtros, busqueda, camposBusqueda, columna);
  const cuenta = new Map();
  base.forEach((f) => {
    const clave = vacio(f[columna]) ? VACIO : String(f[columna]);
    cuenta.set(clave, (cuenta.get(clave) || 0) + 1);
  });
  return [...cuenta.entries()]
    .map(([valor, n]) => ({ valor, n }))
    .sort((a, b) => b.n - a.n || a.valor.localeCompare(b.valor, 'es'));
};
